"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const array_1 = require("../../../common/js/helper/array");
const noop_1 = require("../../../common/js/helper/noop");
const translation_1 = require("../../../common/js/helper/translation");
const Paths_1 = require("../../constants/Paths");
const DataLayerActions_1 = __importDefault(require("../../enums/DataLayerActions"));
const DataLayerLabels_1 = __importDefault(require("../../enums/DataLayerLabels"));
const dataLayer_1 = require("../../helper/dataLayer");
const history_1 = require("../../helper/history");
const ShopwareCart_1 = __importDefault(require("../../stores/ShopwareCart"));
const ShopwareContext_1 = __importDefault(require("../../stores/ShopwareContext"));
const ShopwarePaymentMethods_1 = __importDefault(require("../../stores/ShopwarePaymentMethods"));
const ShopCheckoutLayout_1 = __importDefault(require("../ShopCheckoutLayout"));
const ShopCheckoutRadio_1 = __importDefault(require("../ShopCheckoutRadio"));
class ShopCheckoutPayment extends react_1.default.Component {
    initialLoading = true;
    selectingPaymentMethod = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            initialLoading: mobx_1.observable,
            selectingPaymentMethod: mobx_1.observable,
            isButtonDisabled: mobx_1.computed,
            isPaymentMethodSelectDisabled: mobx_1.computed,
            isLoading: mobx_1.computed,
            selectedPaymentMethodId: mobx_1.computed,
            setPaymentMethod: mobx_1.action.bound,
        });
    }
    get isButtonDisabled() {
        return this.isPaymentMethodSelectDisabled || !this.selectedPaymentMethodId;
    }
    get isPaymentMethodSelectDisabled() {
        return this.isLoading || this.selectingPaymentMethod;
    }
    get isLoading() {
        return ShopwarePaymentMethods_1.default.isLoading || this.initialLoading;
    }
    get selectedPaymentMethodId() {
        return ShopwareContext_1.default.currentPaymentMethod?.id ?? null;
    }
    componentDidMount() {
        (0, dataLayer_1.pushToDataLayer)({
            action: DataLayerActions_1.default.checkoutProgress,
            [DataLayerLabels_1.default.eventLabel]: (0, translation_1.t)('shop_checkout_page.stepper.payment'),
        });
        ShopwarePaymentMethods_1.default
            .loadPaymentMethods()
            .then(() => {
            const validPaymentMethods = ShopwarePaymentMethods_1.default.validPaymentMethods;
            const hasCurrentPaymentMethod = validPaymentMethods.findIndex(this.isSelectedPaymentMethodValid) >= 0;
            // Set valid payment method, if previously selected is not valid anymore.
            const firstPaymentMethod = (0, array_1.first)(ShopwarePaymentMethods_1.default.paymentMethods ?? []);
            if (!hasCurrentPaymentMethod && !!firstPaymentMethod) {
                return ShopwareContext_1.default.setPaymentMethod(firstPaymentMethod.id);
            }
        })
            .finally((0, mobx_1.action)(() => {
            this.initialLoading = false;
        }));
    }
    render() {
        return (react_1.default.createElement(ShopCheckoutLayout_1.default, { className: "znd-shop-checkout-payment-page", title: (0, translation_1.t)('shop_checkout_payment_page.page_title'), submitElement: this.renderSubmitElement(), loading: ShopwareCart_1.default.isLoading },
            react_1.default.createElement("h3", { className: "znd-shop-checkout-payment-page__title" }, (0, translation_1.t)('shop_checkout_payment_page.title')),
            this.isLoading ? (react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                react_1.default.createElement(LoadingSpinner_1.default, null))) : (react_1.default.createElement("div", { className: "znd-shop-checkout-payment-page__methods" }, ShopwarePaymentMethods_1.default.validPaymentMethods.map((paymentMethod) => (react_1.default.createElement(ShopCheckoutRadio_1.default, { key: paymentMethod.id, groupName: "paymentMethod", checked: this.selectedPaymentMethodId === paymentMethod.id, selectableMethod: paymentMethod, disabled: this.isPaymentMethodSelectDisabled, onChange: this.setPaymentMethod, additionalFieldsFullWidth: true })))))));
    }
    setPaymentMethod(selectedMethodId) {
        this.selectingPaymentMethod = true;
        return ShopwareContext_1.default
            .setPaymentMethod(selectedMethodId)
            .then(() => ShopwareCart_1.default.loadCart())
            .then(noop_1.noop)
            .finally((0, mobx_1.action)(() => {
            this.selectingPaymentMethod = false;
        }));
    }
    renderSubmitElement() {
        return (react_1.default.createElement(Button_1.default, { className: "znd-shop-checkout-payment-page__button", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('shop_checkout_payment_page.submit_button'), onClick: () => {
                (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_SHOP_CHECKOUT_SUMMARY);
            }, disabled: this.isButtonDisabled }));
    }
    isSelectedPaymentMethodValid(method) {
        return !!this.selectedPaymentMethodId && this.selectedPaymentMethodId === method.id;
    }
}
__decorate([
    bind_decorator_1.default
], ShopCheckoutPayment.prototype, "renderSubmitElement", null);
__decorate([
    bind_decorator_1.default
], ShopCheckoutPayment.prototype, "isSelectedPaymentMethodValid", null);
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(ShopCheckoutPayment));
